import { DateTime } from 'luxon'

export default {
    computed: {
        locale() {
            return document.documentElement.lang.slice(0, 2)
        },
        FULL_DATE() {
            return {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
            }
        },
        DATE_SHORT() {
            return {
                weekday: 'short',
                year: 'numeric',
                month: 'long',
                day: 'numeric',
            }
        },
        DATE_TIME_SHORT() {
            return {
                hour: 'numeric',
                dayPeriod: 'short',
            }
        },
        DATE_DAY_OF_WEEK() {
            return 'EEEE'
        },
        DATE_YMD() {
            return {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
            }
        },
        TIME_HHMM() {
            return {
                hour: 'numeric',
                minute: 'numeric',
            }
        },
        DATETIME() {
            return {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
            }
        },
        getToday() {
            return DateTime.now().toFormat('yyyy-MM-dd')
        },
    },
    methods: {
        toSystemFormat(date) {
            return DateTime.fromISO(date).toFormat('yyyy-MM-dd')
        },
        addDays(date, days, format = null) {
            let object = DateTime.fromISO(date).plus({ days })
            if (format) return object.toLocaleString(format)
            return object.toFormat('yyyy-MM-dd')
        },
        addMonths(date, months, format = null) {
            let object = DateTime.fromISO(date).plus({ months })
            if (format) return object.toLocaleString(format)
            return object.toFormat('yyyy-MM-dd')
        },
        weekdayNumber(date) {
            return DateTime.fromISO(date).toFormat('c')
        },
        dateFormat(date, format) {
            return DateTime.fromISO(date).toFormat(format)
        },
        formatDate(date, format = null, locale = true) {
            if (format === null) format = this.FULL_DATE
            date = DateTime.fromISO(date).setLocale(this.locale)
            if (typeof format !== 'object') return date.toFormat(format)
            else return date.toLocaleString(format)
        },
        isToday(date) {
            return date === DateTime.now().toISODate()
        },
    }
}
